/** Configurações do blog E-FISIO (só administradores): saúde de SEO e backups. */
import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowLeft, Settings } from "lucide-react";

import { AdminGate } from "@/components/admin/AdminGate";
import { AdminShell } from "@/components/admin/shell";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { BackupsTab } from "@/components/admin/e-fisio/BackupsTab";
import { SeoTab } from "@/components/admin/e-fisio/SeoTab";

export const Route = createFileRoute("/admin/e-fisio_/configuracoes")({
  head: () => ({
    meta: [
      { title: "Admin — Configurações do E-FISIO" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: () => (
    <AdminGate route="/admin/e-fisio">
      <ConfigPage />
    </AdminGate>
  ),
});

function ConfigPage() {
  return (
    <AdminShell
      title="Configurações do E-FISIO"
      description="Área técnica, só para administradores."
      icon={<Settings className="h-6 w-6 text-admin-accent" />}
      actions={
        <Link
          to="/admin/e-fisio"
          className="inline-flex items-center gap-1 rounded-lg border border-white/10 px-3 py-2 text-xs text-white/70 hover:text-admin-accent"
        >
          <ArrowLeft className="h-3.5 w-3.5" /> Voltar ao painel
        </Link>
      }
    >
      <Tabs defaultValue="seo">
        <TabsList className="flex-wrap bg-white/[0.04]">
          <TabsTrigger value="seo">Saúde de SEO</TabsTrigger>
          <TabsTrigger value="backups">Backups e domínio</TabsTrigger>
        </TabsList>
        <TabsContent value="seo" className="mt-6">
          <SeoTab />
        </TabsContent>
        <TabsContent value="backups" className="mt-6">
          <BackupsTab />
        </TabsContent>
      </Tabs>
    </AdminShell>
  );
}
